import axios from 'axios';
import { useApiConfigStore } from '@store/api_config';

const publicClient = axios.create();

publicClient.interceptors.request.use((config) => {
  config.baseURL = useApiConfigStore.getState().getApiUrl();
  return config;
});

export interface SigningPageData {
  doc_title: string;
  project_name: string;
  conductor_name: string;
  signer_name: string;
  pdf_url: string;
  status: 'pending' | 'signed' | 'expired' | 'superseded';
  requires_otp?: boolean;
  signer_phone_masked?: string;
}

export interface SigningResult {
  success: boolean;
  message: string;
  session_token?: string;
}

export const getSigningData = (token: string): Promise<SigningPageData> =>
  publicClient.get(`/generated-documents/sign/${token}`).then((r) => r.data);

export const submitSignature = (token: string, signatureFile: File, otpSessionToken?: string): Promise<SigningResult> => {
  const formData = new FormData();
  formData.append('signature', signatureFile);
  const headers: Record<string, string> = { 'Content-Type': 'multipart/form-data' };
  if (otpSessionToken) {
    headers['X-OTP-Session-Token'] = otpSessionToken;
  }
  return publicClient.post(`/generated-documents/sign/${token}`, formData, { headers }).then((r) => r.data);
};

export const sendOtp = (token: string): Promise<SigningResult> =>
  publicClient.post(`/generated-documents/sign/${token}/send-otp`).then((r) => r.data);

export const verifyOtp = (token: string, code: string): Promise<SigningResult> =>
  publicClient.post(`/generated-documents/sign/${token}/verify-otp`, { code }).then((r) => r.data);
